/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material';
import { TextMaskModule } from 'angular2-text-mask';
import { PriceFormatComponent } from './component/price-format.component';
import { MatPriceFormatComponent } from './component/mat/mat-price-format.component';
const /** @type {?} */ CommonImports = [
    CommonModule,
    FormsModule,
    TextMaskModule
];
export class PriceFormatModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: PriceFormatModule,
            providers: []
        };
    }
}
PriceFormatModule.decorators = [
    { type: NgModule, args: [{
                imports: CommonImports,
                declarations: [PriceFormatComponent],
                exports: [PriceFormatComponent]
            },] },
];
function PriceFormatModule_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    PriceFormatModule.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    PriceFormatModule.ctorParameters;
}
export class MatPriceFormatModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: MatPriceFormatModule,
            providers: []
        };
    }
}
MatPriceFormatModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    ...CommonImports,
                    ReactiveFormsModule,
                    MatInputModule
                ],
                declarations: [MatPriceFormatComponent],
                exports: [MatPriceFormatComponent]
            },] },
];
function MatPriceFormatModule_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    MatPriceFormatModule.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    MatPriceFormatModule.ctorParameters;
}
